// removed by extract-text-webpack-plugin
module.exports = {"root":"ShoutItem__root___2ZZ6_","name":"ShoutItem__name___20Pvf"};


//////////////////
// WEBPACK FOOTER
// ./src/ui/interaction/children/sections/shoutbox/childcomponents/ShoutItem.scss
// module id = 779
// module chunks = 0